// extracted by mini-css-extract-plugin
var _1 = "UserSearchItem-moduleUserSearchItem__XwKln SearchItem-moduleSearchItem__qpbuZ";
export { _1 as "UserSearchItem" }
